import { render, staticRenderFns } from "./WeeklyProgress.vue?vue&type=template&id=70201d0a&scoped=true&"
import script from "./WeeklyProgress.vue?vue&type=script&lang=js&"
export * from "./WeeklyProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70201d0a",
  null
  
)

export default component.exports